import type { FaireProductEntity } from "../../entity_types/product";

export const p_wg7sfharnd: FaireProductEntity = {
  token: "p_wg7sfharnd",
  type: "product",
  name: "farm watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/9b9aa003dda0d57866941d9cac2b8d551ea5ef519e305f890d0ff20db8857af4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f1dcbb078846a7ed3a4954a14968e5cc47bcce6905941f4d9a8c1175328d624.jpeg",
    "https://cdn.faire.com/fastly/f557e1a2b5fabee785885f9d93e6442355642229eceb25137290c4ff3c49b9e5.jpeg",
    "https://cdn.faire.com/fastly/5f08faef290cf8f7d7573c4bfc0e18cca03875f29e1579702904b8441dc9e67f.jpeg",
    "https://cdn.faire.com/fastly/a3e64b8754395254dd8bc7803bed54fdd41245c83afbf61985a7a21ab10486e4.jpeg",
    "https://cdn.faire.com/fastly/65d150369327c247c48b74ebc8a027ec8871077345b9698e27d824f7ff223d4e.jpeg",
    "https://cdn.faire.com/fastly/f24330fa9d7de7acacee45b22a03b13997a69c7a5bdfc01b8993bacb6657b7f2.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve farm illustrations — a red barn, dairy cow, tractor, horse, windmill, sheep, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it a favorite for young painters and the grown-ups who paint alongside them.\n\nStrong in children's, farm-country, and home boutiques. A reliable year-round seller.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:07.843Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
